import { render, staticRenderFns } from "./Agreements.vue?vue&type=template&id=71e5ea99&scoped=true&"
import script from "./Agreements.vue?vue&type=script&lang=js&"
export * from "./Agreements.vue?vue&type=script&lang=js&"
import style0 from "./Agreements.vue?vue&type=style&index=0&id=71e5ea99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5ea99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e5ea99')) {
      api.createRecord('71e5ea99', component.options)
    } else {
      api.reload('71e5ea99', component.options)
    }
    module.hot.accept("./Agreements.vue?vue&type=template&id=71e5ea99&scoped=true&", function () {
      api.rerender('71e5ea99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/person/Agreements.vue"
export default component.exports